






import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class BackButton extends Vue {
  @Prop({ default: "" }) readonly icon!: string;
  @Prop({ default: "" }) readonly id!: string;
  @Prop() readonly text!: string;
  @Prop({ default: "" }) readonly backLink!: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  @Prop({ default: null }) readonly params!: object;
}
